import { useDataFetch } from './Use-data-fetch';

/**
 * Resumen de alertas e insights para las tarjetas del home.
 *
 * Es una versión liviana de [useAlerts]: la home sólo necesita los conteos y
 * los textos, no la tabla paginada de alertas, que es la consulta cara.
 *
 * Usa a propósito las mismas query keys que useAlerts (`alerts-summary` e
 * `insights`), para que al entrar a la página de alertas react-query reutilice
 * lo que ya está en caché en vez de volver a pedirlo.
 */
export const useAlertsOverview = () => {
  const { getData } = useDataFetch();

  const {
    data: summaryResponse,
    isLoading: summaryLoading,
    error: summaryError,
  } = getData(['alerts-summary'], '/alerts/summary');

  const {
    data: insightsResponse,
    isLoading: insightsLoading,
    error: insightsError,
  } = getData(['insights'], '/insights', {}, { limit: 20 });

  return {
    // { FAILED_PURCHASE_ATTEMPTS: n, NETWORK_NO_GROWTH: n, ... }
    countsByType: summaryResponse?.data?.by_type ?? null,
    lastRunAt: summaryResponse?.data?.last_run_at ?? null,

    // [{ id, type, title, text, metrics, generated_at }]
    insights: insightsResponse?.data?.items ?? [],
    insightsGeneratedAt: insightsResponse?.data?.generated_at ?? null,

    summaryLoading,
    insightsLoading,
    error: summaryError || insightsError,
  };
};
